import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {NOOP} from 'components/UIKit/utilities';

import {NavItemData} from '../../interfaces';
import {MegaNavItem} from '..';
import * as styles from './MegaNav.scss';

interface MegaNavProps {
  context?: 'drawer';
  openNavs: string[];
  onBack: () => any;
  onActiveNavs: (itemPath) => any;
  shopNavItems: NavItemData[];
  infoNavItems: NavItemData[];
}

function getEmptyNavItemData(items) {
  return {
    url: '',
    title: '',
    children: items,
    internalName: '',
    pluralizedTitle: '',
  };
}

const backButtonData = {
  url: '',
  children: [],
  title: 'Back',
  pluralizedTitle: 'back',
  internalName: 'back',
};

export class MegaNav extends React.Component<MegaNavProps> {
  refFns: any;
  listRefs: any;

  constructor(props) {
    super(props);

    this.refFns = {};
    this.listRefs = {};
  }

  setRef = (refName, element) => {
    this.listRefs[refName] = element;
  };

  setMenuRef = (refName) => {
    if (this.refFns[refName]) {
      return this.refFns[refName];
    }

    this.refFns[refName] = this.setRef.bind(this, refName);
    return this.refFns[refName];
  };

  resetListScroll = (openNavs) => {
    Object.keys(this.listRefs).forEach((list) => {
      if (openNavs.includes(list)) { return; }
      this.listRefs[list].scrollTop = 0;
    });
  };

  componentWillReceiveProps(newProps) {
    this.resetListScroll(newProps.openNavs);
  }

  renderMenu(item: NavItemData, itemPath: string[] = [], isPrimary: boolean = false) {
    const {openNavs, onBack = NOOP, context} = this.props;

    const isOpen = isPrimary || openNavs.includes(item.internalName);
    const tabIndex = isOpen ? 0 : -1;
    const isDrawer = (context === 'drawer');
    const renderBackButton = !isPrimary && isDrawer;

    const list = (
      <ul ref={this.setMenuRef(item.internalName)} className={isPrimary ? styles.baseList : styles.list}>
        {renderBackButton ? (
          <li className={styles.listItem}>
            <MegaNavItem item={backButtonData} onBack={onBack} tabIndex={tabIndex} back />
          </li>
        ) : null}

        {item.children.map((child) => {
          const {onActiveNavs = NOOP} = this.props;
          const subPath = child.children.length > 0 ? itemPath.concat(child.internalName) : itemPath;

          return (
            <li key={child.internalName} className={styles.listItem}>
              <MegaNavItem
                item={child}
                active={openNavs.includes(child.internalName)}
                tabIndex={tabIndex}
                itemPath={subPath}
                onActive={onActiveNavs}
                activateOnHover={!isDrawer}
              />
              {child.children.length ? this.renderMenu(child, subPath) : null}
            </li>
          );
        })}
      </ul>
    );

    return isPrimary ? list : (
      <div className={classNames(styles.listContainer, {[styles.open]: isOpen})}>
        {list}
      </div>
    );
  }

  render() {
    const {
      context,
      shopNavItems,
      infoNavItems,
    } = this.props;

    const isDrawer = (context === 'drawer');

    return (
      <div className={classNames(styles.baseListContainer, {[styles.drawerContext]: isDrawer})}>
        {this.renderMenu(getEmptyNavItemData(shopNavItems), [], true)}
        {this.renderMenu(getEmptyNavItemData(infoNavItems), [], true)}
      </div>
    );
  }
}

export default MegaNav;
